import { render, staticRenderFns } from "./HeroPro.vue?vue&type=template&id=11875040&"
import script from "./HeroPro.vue?vue&type=script&lang=js&"
export * from "./HeroPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports